import {createSlice} from "@reduxjs/toolkit";
import Nullable from "@/types/utils/Nullable";
import State from "@/types/utils/State";

type AlertType = 'success' | 'error'

interface IAlert{
    message?: Nullable<string>
    show: boolean
    type?: AlertType
}

export interface IUserValue {
    nome?: string
    sobrenome?: string
    email: string
    id_usuario: number
    telefone?: string
    documento?: string
    alert?: IAlert
    assinante?: boolean,
}

const initialState: State<IUserValue> = {
    value: {
        nome: '',
        sobrenome: '',
        email: '',
        id_usuario: 0,
        telefone: '',
        documento: '',
        assinante: false,
        alert: {
            message: null,
            show: false,
            type: 'error'
        }
    }
}

export const usuarioSlice = createSlice({
    name: "usuario",
    initialState,
    reducers: {
        SET_USER: (state, action: {payload: IUserValue}) => {
            if (typeof action.payload !== 'undefined') {
                const {payload} = action
                state.value.nome = payload.nome;
                state.value.sobrenome = payload.sobrenome;
                state.value.email = payload.email
                state.value.id_usuario = payload.id_usuario
                state.value.telefone = payload.telefone
                state.value.documento = payload.documento
                state.value.assinante = payload.assinante
            }
        },
        SET_USER_ALERT: (state, action: {payload: IAlert}) => {
            const {payload} = action
            if(state.value.alert){
                state.value.alert.show = payload.show;
                state.value.alert.message = payload.message
                state.value.alert.type = payload.type
            }
        }
    }
})

export const {SET_USER} = usuarioSlice.actions
export const {SET_USER_ALERT} = usuarioSlice.actions

export const GET_USER = (state: any): IUserValue => state.usuario.value
export const GET_USER_ALERT = (state: any): IAlert => state.usuario.value.alert

export default usuarioSlice.reducer